import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounce';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import { ACTION_PARENT_TRIALS_LOAD, IParentTrialsLoadAction, IParentTrialsLoadFailureAction, IParentTrialsLoadSuccessAction, LoadFailure, LoadSuccess } from 'src/actions/parentTrials';
import { parentTrialsApi } from "../services/parentTrials";


export const
    getParentTrialsEpic = (action$): Observable<IParentTrialsLoadSuccessAction | IParentTrialsLoadFailureAction> => {
        return action$
            .ofType(ACTION_PARENT_TRIALS_LOAD)
            .mergeMap((_action: IParentTrialsLoadAction) => {
                return parentTrialsApi
                    .getParentTrials()
                    .map(response => 
                        LoadSuccess(response.trials)
                    )
                    .catch(error => 
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    }